import { BreadcrumbBuilder, ListItemBuilder } from '@at/schema-utils/lib/builders/breadcrumbs';
export var buildBreadcrumbSchema = function (pathSegments) {
    return pathSegments
        .reduce(function (acc, path, index) {
        return acc.withListItem(ListItemBuilder.aBuilder()
            .withId(path.link || '')
            .withName(path.copy)
            .withPosition(index + 1)
            .build());
    }, new BreadcrumbBuilder())
        .build();
};
